// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__OFSF8","list":"styles_list__2aIP-"};